import { Header } from "../components/Header";
import { Text } from "../components/Text";
import { Box } from "../components/Box";
import { Button } from "../components/Button";
import { useRef, useState } from "react";
import { fileUploader } from "../services/FileUploader";

export function FileUploadPage() {
  const inputFile = useRef<HTMLInputElement>(null) 
  const [isUploading, setIsUploading] = useState(false)
  const [publicFileUrl, setPublicFileUrl] = useState('')
  const [hasCopied, setHasCopied] = useState(false)

  async function copyLink() {
    await navigator.clipboard.writeText(publicFileUrl);
    setHasCopied(true)
    setTimeout(() => {
      setHasCopied(false)
    }, 2000);
  }

  async function uploadFile() {
    if (isUploading) {
      return;
    }
    setIsUploading(true)
    const file = inputFile.current?.files?.[0]
    if (file) {
      const response = await fileUploader.upload(file)
      console.log({response})
      setPublicFileUrl(response.url)
      setIsUploading(false)
    }
  }

  return (
    <>
      <Header />

      <Box 
        alignHorizontal="center" 
        alignVertical="center" 
        direction="vertical"
        paddingTopCode="xl"
      >

        <Box paddingTopCode="xl" />

        <Text size="xxl" weight="strong">
           Upload File
        </Text>

        <Box paddingTopCode="xs" />

        <div style={{ position: 'absolute', right: '100%', bottom: '100%' }}>
          <input 
            type="file" 
            ref={inputFile}
            onChange={uploadFile}
          />
        </div>

        <Text size="md" color="secondary">
          Upload a file to GCP and get a public link
        </Text>

        <Box paddingTopCode="xl" />

        {publicFileUrl && (
          <Box paddingBottomCode="xl">
            <Text size="md">{publicFileUrl}</Text>
          </Box>
        )}

        {publicFileUrl && (
          <Button onClick={copyLink} label={hasCopied ? 'Copied!' : 'Copy Link'} />
        )}

        {!publicFileUrl && (
          <Button label="Upload File" onClick={() => {
            if (inputFile.current) {
              inputFile.current.click();
            }
          }} />
        )}

      </Box>
    </>
  )
}